import { render, staticRenderFns } from "./AdminPayments.vue?vue&type=template&id=4d5b36d5&scoped=true"
import script from "./AdminPayments.vue?vue&type=script&lang=js"
export * from "./AdminPayments.vue?vue&type=script&lang=js"
import style0 from "./AdminPayments.vue?vue&type=style&index=0&id=4d5b36d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b36d5",
  null
  
)

export default component.exports